import { css, Theme } from '@mui/material'
import { Branding } from '../types'

export const brandedTopBarBlock = ({
  theme,
  branding,
}: {
  theme: Theme
  branding: Branding | undefined
}) => css`
  color: ${branding?.primaryContrast ?? theme.palette.white.main};
  background-color: ${branding?.primary ?? theme.palette.primary.main};
  flex-grow: 0;
  height: 74px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  column-gap: ${theme.spacing(8)};
  box-shadow: 0 ${theme.spacing(0.5)} ${theme.spacing(1)} rgba(0, 0, 0, 0.2);
  z-index: 1;

  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.48px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  padding: 0 ${theme.spacing(4)};

  ${theme.breakpoints.down('lg')} {
    column-gap: ${theme.spacing(4)};
    font-size: 22px;
    height: 68px;
  }

  ${theme.breakpoints.down('md')} {
    column-gap: ${theme.spacing(3)};
    font-size: 20px;
    height: 64px;
    padding: 0 ${theme.spacing(2)};
  }

  ${theme.breakpoints.down('sm')} {
    column-gap: ${theme.spacing(2)};
    font-size: 10px;
    height: 60px;
    padding: 0 ${theme.spacing(1.5)};
  }
`

export const rexLogo = (theme: Theme) => css`
  padding-left: 32px;
  height: ${theme.spacing(11)};
  display: block;
  flex-shrink: 0;
  object-fit: contain;

  ${theme.breakpoints.down('lg')} {
    padding-left: 24px;
    height: 40px;
  }

  ${theme.breakpoints.down('md')} {
    padding-left: 16px;
    height: ${theme.spacing(9)};
  }

  ${theme.breakpoints.down('sm')} {
    padding-left: 12px;
    height: ${theme.spacing(7)};
  }
`

export const clientLogo = (theme: Theme) => css`
  padding-right: 32px;
  height: ${theme.spacing(11)};
  display: block;
  margin-left: auto;
  flex-shrink: 0;
  object-fit: contain;

  ${theme.breakpoints.down('lg')} {
    padding-right: 24px;
    height: 68px;
  }

  ${theme.breakpoints.down('md')} {
    padding-right: 16px;
    height: 60px;
    display: none;
  }
`
